common.View.create('shop::website.modules.shopCheckout.cart.partials.MiniCart', {

	onDOMLoad()
	{
	    this.initMiniCart();
	    this.initMiniCartClose();
		this.initAmountInput();
		this.initDeleteButton();
	},

    initMiniCart()
    {
        // Click on continue shopping
        this.element.on('click', '.continueShopping', (event) => {
            // Toggle mini cart
            this.element.find('> *').toggleClass('triggered');

            return false;
        });

        $('.shop\\:\\:website-modules-shopCheckout-cart-partials-Amount')
            .on('click', (event) => {
                // Has items in Mini cart?
                if( $(event.currentTarget).find('.amount').html() > 0
                    && !$(event.currentTarget).data('nominicart')
                ) {
                    // Toggle mini cart
                    this.element.find('> *').toggleClass('triggered');

                    return false;
                }
            });
    },

    async replaceMiniCart(miniCartView, triggered = true)
    {
        let $miniCartView = $(miniCartView).find('.context');

        // Is triggered?
        if( triggered && $miniCartView.find('.cartItems > *').length ) {
            $miniCartView.addClass('triggered');
        }

        // Update mini cart items
        await this.element
            .find('.context')
                .replaceWith( $miniCartView )
                .end();
    },

    initMiniCartClose()
    {
        $('body').on('click', (event) => {
            // If target click is not the container or descendant of the container
            if (!this.element.find('> *').is(event.target)
                && !$(event.target).is('button[name="addToCart"], button[name="addToCart"] i')
                && !$(event.target).is('.swal2-cancel, .swal2-confirm')
                && this.element.find('> *').has(event.target).length === 0) {

                // Toggle mini cart
                this.element.find('> *').removeClass('triggered');
            }
        });
    },

	initDeleteButton()
	{
		// Listen for delete click.
		this.element
			.on('click', 'button[name="delete"]', async (event) =>
			{
				// Abort due to unconfirmed?
				if (!(await Swal.fire({
					title: 'Zeker weten?',
					text: 'Weet u zeker dat u dit product wilt verwijderen?',
					icon: 'warning',
					showCancelButton: true,
					cancelButtonColor: '#707070',
					cancelButtonText: 'Nee, behoud',
					confirmButtonColor: '#6cba2c',
					confirmButtonText: 'Ja, verwijder'
				})).value)
					return;

				// Update
				await this.setDealAmount(0, $(event.currentTarget).parents('.shop\\:\\:website-modules-shopCheckout-cart-ItemSmall'));
			});
	},

	initAmountInput()
	{
		//
		let timeout = null;

		// Listen for amount input change.
		this.element
			.on('input', 'input[name="amount"]', async (event) =>
			{
                $('.to-shopping-cart').attr('disabled', true);

				// No value due to user still typing?
				if ($(event.currentTarget).val() === '') {
				    // Cancel update when user still typing
                    clearTimeout(timeout);
					return;
				}

				// Cancel pending update?
				if (timeout) {
                    clearTimeout(timeout);
                }

				// Deffer updating.
				timeout = setTimeout(async () => this.setDealAmount(
				    $(event.currentTarget).val(),
                    $(event.currentTarget).parents('.shop\\:\\:website-modules-shopCheckout-cart-ItemSmall')
                ), 1000)
			});
	},

	async setDealAmount(amount, cartItemElement)
	{
		// Set as loading.
		let indexInstance = this.element.data('instance');
		indexInstance.setLoading();

        // Set cart as loading as well?
        let cartIndexInstance = $('.shop\\:\\:website-modules-shopCheckout-cart-Index').data('instance');
        if( cartIndexInstance ) {
            cartIndexInstance.setLoading();
        }

		// Set amount to 1 if user decides to enter negative number
		if (amount < 0) {
			amount = 1;
		}

		// Request
		let response = await $.post(this.element.data('url') + '/amount/' + cartItemElement.data('product-variant-id'), {
			_method: 'PATCH',
			amount,
		});

		// Update amount in header.
		$('.website\\:\\:layouts-main-Header').data('instance')
			.setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView);

        // Set new HTML in cart.
        if( cartIndexInstance ) {
            cartIndexInstance.setHtml(response.html);
        }
	},

    setLoading()
    {
        this.element

            .find('.context')
                // Show loading.
                .addClass('loading')

                // Disable inputs.
                .find('input')
                    .attr('readonly', true)
                    .end()

                // Disable buttons.
                .find('button')
                    .attr('disabled', true)
                    .end()

            .end();
    },

});
